<template>
    <div class="form">
        <div class="form-row" v-if="currentUser.can('accessSubclient')">
            <div class="form-row__col form-row__col--one-half">
                <v-select
                    v-model="filterByClient"
                    :placeholder="this.trans('users.label.client')"
                    :options="this.clients"
                    @change="emitFilterChangedEvent"
                    class="form-vue-select"
                >
                    <div slot="no-options">
                        {{ trans('vue_select.no_options') }}
                    </div>
                </v-select>
            </div>
            <div class="form-row__col" v-if="filterByClient">
                <checkbox
                    @change="emitFilterChangedEvent"
                    v-model="hideSubclientUsers"
                >
                    {{ trans('users.label.hide_subclient_users') }}
                </checkbox>
            </div>
        </div>
        <div class="form-row">
            <div class="form-row__col form-row__col--one-half">
                <v-select
                    v-model="filterByRole"
                    :placeholder="this.trans('users.label.role')"
                    :options="this.roleOptions"
                    @change="emitFilterChangedEvent"
                    class="form-vue-select"
                >
                    <div slot="no-options">
                        {{ trans('vue_select.no_options') }}
                    </div>
                </v-select>
            </div>
        </div>
        <div class="form-row">
            <div class="form-row__col">
                <checkbox
                    @change="emitFilterChangedEvent"
                    v-model="onlyUsersWithoutUsergroup"
                >
                    {{ trans('users.label.only_without_usergroup') }}
                </checkbox>
            </div>
        </div>
        <div class="form-row">
            <div class="form-row__col">
                <checkbox
                    @change="emitFilterChangedEvent"
                    v-model="onlyUsersWithoutCourseAssignment"
                >
                    {{ trans('users.label.only_without_course_assignment') }}
                </checkbox>
            </div>
        </div>
        <div class="form-row">
            <div class="form-row__col" v-if="currentUser.can('restoreUser')">
                <checkbox
                    @change="emitFilterChangedEvent"
                    v-model="showDeletedUsersOnly"
                    >{{ trans('search.only_deleted_users') }}</checkbox
                >
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../eventbus';

export default {
    data() {
        return {
            clients: [],
            filterByClient: null,
            filterByRole: null,
            roleOptions: [
                { value: 5, label: this.trans('users.role.client_admin') },
                { value: 8, label: this.trans('users.role.supervisor') },
                { value: 6, label: this.trans('users.role.controller') },
                { value: 7, label: this.trans('users.role.end_user') }
            ],
            hideSubclientUsers: false,
            showDeletedUsersOnly: false,
            onlyUsersWithoutUsergroup: false,
            onlyUsersWithoutCourseAssignment: false
        };
    },
    methods: {
        emitFilterChangedEvent() {
            EventBus.$emit('filterChanged', this.$data);
        },

        refresh(data) {
            axios
                .get(this.route('tenantapi.clients.index.flat'))
                .then(({ data }) => {
                    this.clients = data.map(client => {
                        return {
                            value: client.id,
                            label: client.name,
                            ...client
                        };
                    });
                });
        }
    },
    watch: {
        filterByClient(newFilterClient) {
            // Unset subclient filter when setting filter client to null
            if (!newFilterClient) {
                this.hideSubclientUsers = false;
            }
        }
    },
    mounted() {
        this.refresh();
    }
};
</script>
